<template>
  <v-container>
    <v-row>
      <v-col cols="12" v-if="chartData">
        <RadarChart
            :chartData="chartDataCopy"
            :options="options"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import RadarChart from "../base/RadarChart.vue";
import ChartTitle from "../components/ChartTitle.vue";
import {computed} from "vue";
import Utils from "../../Mixins/Utils";
import StringManipulation from "../../Mixins/StringManipulation";

const props = defineProps({
  title: {
    type: String,
    default: null,
    required: false
  },
  chartData: {
    type: Object,
    required: true
  },
})

const chartDataCopy = computed(() => {
  const dataCopy = Utils.methods.deepCopy(props.chartData)
  dataCopy.labels = dataCopy.labels.map(item => {
    const label = item === "Ict" ? "ICT" : item;
    return StringManipulation.methods.wrapText(label);
  });
  return dataCopy
})

const options = computed(() => {
  return {
      plugins:{
        legend: {
          display: false,
        },
        title: {
          display: true,
          fullSize: true,
          text: props.title,
          color: 'black',
          font: {
            size: 22,
            family: 'Verdana',
          }
        },
      },
    scales: {
      r: {
        beginAtZero: true,
        max: 5,
        grid: {
          color: '#dadada'
        },
        ticks: {
          stepSize: 1,
        },
        pointLabels: {
          color: '#1e1e1e',
          font: (context) => {
            const label = context.label;
            let size = 16;
            if (Array.isArray(label)) {
              if (label.length > 3) size = 10;
              else if (label.length > 2) size = 12;
              else if (label.length > 1) size = 14;
            } else if (label.length > 20) {
              size = 12;
            }
            return {
              size: size
            };
          }
        }
      }
    }
  }
})
</script>

<style scoped>

</style>
